module.exports = __webpack_public_path__ + "static/img/M2.e96d0d1f.png";